import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14 11H5v-1h9v1zM9.5 3C5.364 3 2 6.364 2 10.5S5.364 18 9.5 18s7.5-3.364 7.5-7.5S13.636 3 9.5 3zm0-1c4.675 0 8.5 3.825 8.5 8.5S14.175 19 9.5 19 1 15.175 1 10.5 4.825 2 9.5 2z',
  ],
  height: 20,
  width: 20,
});
